import React from "react";
import "./LeaveEligibilityTile.css";
import { Grid } from "@mui/material";
import { fonts, themes } from "../../themes/themes";

interface contentTileType {
  leaveName: string;
  totalLeaves: number;
}
const LeaveEligibilityTile: React.FC<contentTileType> = ({
  leaveName,
  totalLeaves,
}) => {
  return (
    <Grid container className="leaveEligibilityTile-container">
      <Grid
        item
        xs={1}
        style={{
          fontSize: fonts.subtitle,
          color: themes.primary,
        }}
      >
        <i className="las la-plus" />
      </Grid>
      <Grid
        item
        xs={10}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.defaultIcon,
          textTransform: "capitalize",
        }}
      >
        {leaveName}
      </Grid>
      <Grid
        item
        xs={1}
        style={{
          fontSize: fonts.subtitle,
          fontFamily: fonts.fontFamily,
          color: themes.blackDefault,
          textAlign: "right",
          textTransform: "capitalize",
        }}
      >
        {totalLeaves}
      </Grid>
    </Grid>
  );
};

export default LeaveEligibilityTile;
